(function ($) {
  multiProdSkuFormatterV1 = {
    formatter: $('.multi-prod-sku-formatter-v1')
  };

  Drupal.behaviors.multiProdSkuFormatterV1 = {
    get: function (key) {
      return multiProdSkuFormatterV1[key];
    },

    set: function (key, val) {
      multiProdSkuFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.once('multi-prod-sku-formatter-v1-init-processed').each(function () {
        var thisFormatter = $(this);
      });
    }
  };
})(jQuery);
